export var suffixLetter = function (ordinal) {
    var result = "";
    var remaining = ordinal;
    while (remaining > 0) {
        remaining--;
        result = String.fromCharCode(97 + (remaining % 26)) + result;
        remaining = Math.floor(remaining / 26);
    }
    return result;
};
